import * as React from 'react';

import * as styles from './BookingInfoConstructor.css';
import { BlockTitle, Paragraphs, Sections } from './components';
import { IBookingInfoBlock } from './types';

interface IBookingInfoConstructorProps {
  blocks: IBookingInfoBlock[];
}

export const BookingInfoConstructor = ({ blocks }: IBookingInfoConstructorProps) => {
  return (
    <>
      {blocks.map(({ title, sections, paragraphs }, index) => (
        <div className={styles['block']} key={title || index}>
          <BlockTitle>{title}</BlockTitle>
          <Sections>{sections}</Sections>
          <Paragraphs>{paragraphs}</Paragraphs>
        </div>
      ))}
    </>
  );
};
